import { render } from "./forooshgahi.vue?vue&type=template&id=bd5be37e"
import script from "./forooshgahi.vue?vue&type=script&lang=js"
export * from "./forooshgahi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/mixitweb-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__